(() => {
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const root = (window.themeRoutes && window.themeRoutes.root) || '/';
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {
    style: 'currency', currency: window.themeCurrency || 'EUR'
  }).format((Number(cents) || 0) / 100);
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);

  const toast = (message) => {
    const node = $('[data-toast]');
    if (!node) return;
    node.textContent = message;
    node.classList.add('show');
    window.clearTimeout(node._timer);
    node._timer = window.setTimeout(() => node.classList.remove('show'), 2400);
  };

  const cartDrawer = $('[data-cart-drawer]');
  const cartOverlay = $('[data-cart-overlay]');
  const openCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.hidden = false;
    requestAnimationFrame(() => cartOverlay.classList.add('is-open'));
    document.body.classList.add('drawer-open');
    $('[data-cart-close]', cartDrawer)?.focus();
  };
  const closeCart = () => {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
    window.setTimeout(() => { if (cartOverlay) cartOverlay.hidden = true; }, 250);
  };

  const emptyCartMarkup = () => `<div class="empty-cart"><span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8h14l-1 13H6L5 8Z"></path><path d="M9 9V6a3 3 0 0 1 6 0v3"></path></svg></span><h3>Tu cesta está esperando</h3><p>Elige tu variedad favorita y prepara sitio en la nevera.</p><a href="${root}collections/all" class="button button-primary">Productos</a></div>`;
  const cartLineMarkup = (item) => `<article class="cart-line" data-cart-key="${escapeHtml(item.key)}">
    <a href="${escapeHtml(item.url)}">${item.image ? `<img src="${escapeHtml(item.image)}&width=192" alt="${escapeHtml(item.product_title)}" width="96" height="96" loading="lazy">` : ''}</a>
    <div><h3>${escapeHtml(item.product_title)}</h3>${item.variant_title ? `<p>${escapeHtml(item.variant_title)}</p>` : ''}<strong>${money(item.final_line_price)}</strong>
    <div class="quantity-row"><button type="button" data-cart-change="${item.quantity - 1}" aria-label="Restar">−</button><span>${item.quantity}</span><button type="button" data-cart-change="${item.quantity + 1}" aria-label="Añadir">+</button><button class="remove-line" type="button" data-cart-change="0">Eliminar</button></div></div></article>`;

  const renderCart = (cart) => {
    $$('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const lines = $('[data-cart-lines]');
    const footer = $('[data-cart-footer]');
    if (lines) lines.innerHTML = cart.items.length ? cart.items.map(cartLineMarkup).join('') : emptyCartMarkup();
    if (footer) {
      footer.hidden = !cart.items.length;
      const total = $('[data-cart-total]', footer);
      if (total) total.textContent = money(cart.total_price);
    }
  };
  const getCart = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((response) => response.json());
  const changeCart = (key, quantity) => fetch(`${root}cart/change.js`, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity })
  }).then((response) => {
    if (!response.ok) throw new Error('No se pudo actualizar la cesta');
    return response.json();
  });

  $$('[data-cart-open]').forEach((button) => button.addEventListener('click', openCart));
  $('[data-cart-close]')?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCart(); });
  cartDrawer?.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-cart-change]');
    if (!button) return;
    const line = button.closest('[data-cart-key]');
    if (!line) return;
    button.disabled = true;
    try { renderCart(await changeCart(line.dataset.cartKey, Number(button.dataset.cartChange))); }
    catch (error) { toast(error.message); }
  });

  const addForm = async (form) => {
    const button = $('button[type="submit"]', form);
    if (button) button.disabled = true;
    try {
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.description || 'No se pudo añadir el producto');
      }
      renderCart(await getCart());
      openCart();
    } catch (error) { toast(error.message); }
    finally { if (button) button.disabled = false; }
  };
  $$('[data-product-form], [data-quick-add]').forEach((form) => form.addEventListener('submit', (event) => { event.preventDefault(); addForm(form); }));

  const searchToggle = $('[data-search-toggle]');
  const searchPanel = $('[data-search-panel]');
  searchToggle?.addEventListener('click', () => {
    const opening = searchPanel.hidden;
    searchPanel.hidden = !opening;
    searchToggle.setAttribute('aria-expanded', String(opening));
    if (opening) $('input[type="search"]', searchPanel)?.focus();
  });
  const menuToggle = $('[data-menu-toggle]');
  const mobileMenu = $('[data-mobile-menu]');
  menuToggle?.addEventListener('click', () => {
    const opening = mobileMenu.hidden;
    mobileMenu.hidden = !opening;
    menuToggle.setAttribute('aria-expanded', String(opening));
  });
  $('[data-language-select]')?.addEventListener('change', (event) => event.target.form.submit());
  $('[data-sort-select]')?.addEventListener('change', (event) => event.target.form.submit());

  $$('[data-product-root]').forEach((productRoot) => {
    const variantsNode = $('[data-product-json]', productRoot.parentElement || document) || $('[data-product-json]');
    const select = $('[data-variant-select]', productRoot);
    const quantity = $('[data-quantity]', productRoot);
    $('[data-quantity-minus]', productRoot)?.addEventListener('click', () => { quantity.value = Math.max(1, Number(quantity.value) - 1); });
    $('[data-quantity-plus]', productRoot)?.addEventListener('click', () => { quantity.value = Number(quantity.value) + 1; });
    if (variantsNode && select) {
      const variants = JSON.parse(variantsNode.textContent);
      const updateVariant = () => {
        const options = $$('[data-option-index]', productRoot).map((group) => $('input:checked', group)?.value);
        const variant = variants.find((item) => item.options.every((value, index) => value === options[index]));
        if (!variant) return;
        select.value = variant.id;
        const price = $('[data-product-price]', productRoot);
        if (price) price.innerHTML = `<div class="price"><span class="price-current">${money(variant.price)}</span>${variant.compare_at_price > variant.price ? `<s>${money(variant.compare_at_price)}</s>` : ''}</div>`;
        const add = $('[data-add-to-cart]', productRoot);
        if (add) { add.disabled = !variant.available; add.textContent = variant.available ? 'Añadir a la cesta' : 'Agotado'; }
        const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
      };
      $$('[data-option-index] input', productRoot).forEach((input) => input.addEventListener('change', updateVariant));
    }
  });
  $$('[data-media-src]').forEach((button) => button.addEventListener('click', () => {
    const visual = button.closest('.product-gallery')?.querySelector('.detail-visual img');
    if (visual) {
      // La imagen se sirve con srcset; si no se vacia, el navegador lo sigue
      // usando y el cambio de src no se ve.
      visual.removeAttribute('srcset');
      visual.removeAttribute('sizes');
      visual.src = button.dataset.mediaSrc;
    }
    $$('[data-media-src]', button.parentElement).forEach((node) => node.classList.toggle('active', node === button));
  }));

  $$('[data-product-recommendations]').forEach(async (section) => {
    if (section.innerHTML.trim()) return;
    try {
      const response = await fetch(section.dataset.url);
      const html = document.createElement('div'); html.innerHTML = await response.text();
      const fresh = $('[data-product-recommendations]', html);
      if (fresh?.innerHTML.trim()) section.innerHTML = fresh.innerHTML;
    } catch (_) { /* Recommendations are optional. */ }
  });

  $('[data-show-recover]')?.addEventListener('click', () => { $('#CustomerLoginForm').hidden = true; $('#RecoverPasswordForm').hidden = false; });
  $('[data-hide-recover]')?.addEventListener('click', () => { $('#CustomerLoginForm').hidden = false; $('#RecoverPasswordForm').hidden = true; });
  $('[data-address-new]')?.addEventListener('click', () => { const form = $('[data-address-form]'); form.hidden = !form.hidden; });

  const cookie = $('[data-cookie-banner]');
  const consentFallbackKey = 'moyca-cookie-consent-v1';
  const showCookie = () => { if (cookie) cookie.hidden = false; };
  const hideCookie = () => { if (cookie) cookie.hidden = true; };
  /* Leer y escribir con red: en navegación privada de algunos móviles el
     almacenamiento puede fallar, y eso no debe romper el resto de la página. */
  const readConsent = () => { try { return localStorage.getItem(consentFallbackKey); } catch (e) { return null; } };
  const saveConsent = (choice) => { try { localStorage.setItem(consentFallbackKey, choice); } catch (e) { /* sin almacenamiento: se preguntará otra vez */ } };
  const tellShopify = (analytics, done) => {
    if (window.Shopify?.customerPrivacy?.setTrackingConsent) {
      window.Shopify.customerPrivacy.setTrackingConsent({ analytics, marketing: analytics, preferences: analytics, sale_of_data: false }, done || (() => {}));
    } else if (done) done();
  };
  const setConsent = (analytics) => {
    saveConsent(analytics ? 'all' : 'necessary');
    hideCookie();
    tellShopify(analytics);
  };
  const initPrivacy = () => {
    if (!cookie) return;
    const privacy = window.Shopify?.customerPrivacy;
    const stored = readConsent();

    if (stored) {
      /* Ya eligió. Si Shopify no se enteró, se le dice ahora. */
      if (privacy?.shouldShowBanner?.()) tellShopify(stored === 'all');
      return;
    }

    /* Sin decisión guardada aquí, pero quizá Shopify sí la tiene (p. ej. se
       borró el almacenamiento y quedó su cookie): se recupera y no se pregunta. */
    const known = privacy?.currentVisitorConsent?.()?.analytics;
    if (known === 'yes' || known === 'no') {
      saveConsent(known === 'yes' ? 'all' : 'necessary');
      return;
    }

    showCookie();
  };

  if (cookie && window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], initPrivacy);
  else initPrivacy();
  $$('[data-consent="all"]').forEach((button) => button.addEventListener('click', () => setConsent(true)));
  $$('[data-consent="necessary"]').forEach((button) => button.addEventListener('click', () => setConsent(false)));
  $('[data-consent-save]')?.addEventListener('click', () => setConsent(Boolean($('[data-consent-analytics]')?.checked)));
  $$('[data-cookie-close]').forEach((button) => button.addEventListener('click', hideCookie));
  $$('[data-cookie-settings]').forEach((button) => button.addEventListener('click', () => {
    showCookie();
    $('[data-cookie-options]')?.removeAttribute('hidden');
    $$('[data-consent], [data-cookie-settings]', cookie).forEach((node) => { node.hidden = true; });
    const save = $('[data-consent-save]', cookie); if (save) save.hidden = false;
  }));

  /* -------------------------------------------------------------------------
     NEWSLETTER → KLAVIYO
     El formulario es el del tema (con su diseño), pero el correo se envía a
     Klaviyo por detrás, sin recargar la página ni usar sus formularios.

     Solo actúa si en el editor se han rellenado la lista y la clave pública;
     si no, el formulario sigue funcionando como el de Shopify de siempre.
     ------------------------------------------------------------------------- */
  $$('.newsletter-form[data-klaviyo-list][data-klaviyo-key]').forEach((form) => {
    const lista = form.dataset.klaviyoList;
    const clave = form.dataset.klaviyoKey;
    if (!lista || !clave) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const campo = form.querySelector('input[type="email"]');
      const boton = form.querySelector('button[type="submit"], button:not([type])');
      const correo = campo?.value.trim();
      if (!correo) return;

      const textoOriginal = boton ? boton.innerHTML : '';
      if (boton) { boton.disabled = true; boton.textContent = 'Enviando…'; }

      try {
        const cuerpo = new URLSearchParams();
        cuerpo.append('g', lista);
        cuerpo.append('email', correo);
        cuerpo.append('$fields', '$source');
        cuerpo.append('$source', 'newsletter-tienda');

        await fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe?company_id=${clave}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: cuerpo
        });

        /* La respuesta de Klaviyo no se puede leer desde el navegador (es de
           otro dominio), así que se da por bueno el envío: la petición sale.
           Es el comportamiento normal de este endpoint. */
        form.innerHTML = '<p class="form-success">¡Gracias! Ya estás en la lista.</p>';
      } catch (error) {
        if (boton) { boton.disabled = false; boton.innerHTML = textoOriginal; }
        /* Si Klaviyo falla, se envía por el camino de Shopify para no perder
           el contacto. */
        form.submit();
      }
    });
  });

  /* -------------------------------------------------------------------------
     POLÍTICAS: el emoji y su título, en una línea y en negrita.

     CÓMO LLEGA EL HTML DE VERDAD (comprobado en la tienda):
       - Los tres bloques van en UN SOLO <p>, separados por <br><br>.
       - Los emojis NO son texto: son <img class="an1" alt="🚚"> que mete el
         editor de Shopify.
       - Cada línea va dentro de un <span>.

     QUÉ HACE:
       1. Parte ese párrafo por los saltos dobles: cada trozo es un bloque.
       2. Si un bloque empieza por <img> (el emoji), su primera línea pasa a ser
          un <h3> con el emoji delante.
       3. El resto del bloque queda debajo, como párrafo normal.
     ------------------------------------------------------------------------- */
  (() => {
    const zona = $('.shopify-policy__body');
    if (!zona) return;

    $$('p', zona).forEach((parrafo) => {
      const html = parrafo.innerHTML;

      /* Un bloque por cada salto doble. Si no hay ninguno, no hay nada que hacer. */
      const bloques = html.split(/(?:<br\s*\/?>\s*){2,}/i)
        .map((t) => t.trim())
        .filter((t) => t !== '');
      if (bloques.length < 2) return;

      const nuevos = document.createDocumentFragment();

      bloques.forEach((bloque) => {
        /* Las líneas de dentro del bloque (saltos sueltos). */
        const lineas = bloque.split(/<br\s*\/?>/i).map((t) => t.trim()).filter(Boolean);
        const primera = lineas[0] || '';

        /* ¿La primera línea empieza por el emoji? Puede ser <img> o un carácter. */
        const llevaEmoji = /^<img\b/i.test(primera) ||
                           /^\s*\p{Extended_Pictographic}/u.test(primera.replace(/<[^>]*>/g, ''));

        if (llevaEmoji) {
          const h = document.createElement('h3');
          h.innerHTML = lineas.shift();
          nuevos.appendChild(h);
        }

        if (lineas.length) {
          const p = document.createElement('p');
          p.innerHTML = lineas.join('<br>');
          nuevos.appendChild(p);
        }
      });

      parrafo.parentNode.replaceChild(nuevos, parrafo);
    });
  })();
})();
